import { AppointmentState } from "../../appointment-details/appointment-details.types.js";
import { useQueryClient, useMutation } from "@tanstack/react-query";
import { toPatchRequestData, getAppointmentStatus } from "../components/appointment-status-select/appointment-status-select.helpers.js";
import { useAxiosProvider } from "../components/AxiosProvider.js";
import { useQueryKey } from "../query-key-provider.js";
import "../../../../utils/time/time.js";
import "date-fns";
import "react/jsx-runtime";
import "react";
import "axios";
const patchAppointmentStatus = (axios) => async (referenceId, params) => {
  const parsedData = toPatchRequestData(params);
  const { data } = await axios.patch(`/api/v1/internal/appointments/${referenceId}/status`, parsedData);
  return data;
};
const useStatusChange = () => {
  const queryClient = useQueryClient();
  const { echoCore } = useAxiosProvider();
  const patientTodayLstQueryKey = useQueryKey();
  return useMutation(({ referenceId, ...params }) => patchAppointmentStatus(echoCore)(referenceId, params), {
    onMutate: async (data) => {
      await queryClient.cancelQueries({ queryKey: patientTodayLstQueryKey });
      const updatedAppointmentDetails = toPatchRequestData(data);
      const updatedAppointmentStatus = getAppointmentStatus(updatedAppointmentDetails);
      const prevList = queryClient.getQueryData(patientTodayLstQueryKey) || [];
      queryClient.setQueryData(
        patientTodayLstQueryKey,
        (prevList2) => {
          if (!prevList2)
            return;
          return prevList2.map((item) => {
            if (item.referenceId === data.referenceId) {
              return {
                ...item,
                appointment: {
                  ...item.appointment,
                  state: updatedAppointmentStatus
                }
              };
            }
            return item;
          }).filter((item) => item.appointment.state !== AppointmentState.CANCELED);
        }
      );
      return { prevList };
    },
    onError: (error, _, context) => {
      queryClient.setQueryData(patientTodayLstQueryKey, context == null ? void 0 : context.prevList);
      console.error(error);
    }
  });
};
export {
  useStatusChange as default
};
